'use client';

import NewsletterSubscribeWidget from '@launchpad/components/pages/Main/ui/widgets/NewsletterSubscribeWidget';

import Socials from '../../common/Socials/Socials';
import Projects from './ui/Projects/Projects';

const Page = () => {
  return (
    <>
      <div className="h-[14rem] bg-page-gradient absolute w-full"></div>
      <div className="relative">
        <main className="main-container pb-16">
          <div className="my-6 md:mb-14 md:mt-12 text-center">
            <h1 className="mb-3 md:mb-4 text-[28px] md:text-[40px] font-semibold">
              Token Sales: Active, Upcoming & Completed
            </h1>
            <div className="text-base-text-tertiary font-medium text-[12px] md:text-[16px] ">
              Explore live sales, join upcoming launches, and review past performances.
            </div>
          </div>

          <Projects type="active" />
          <Projects type="coming" />
          <Projects type="passed" />
          <NewsletterSubscribeWidget className="my-12 md:my-16" />
          <Socials />
        </main>
      </div>
    </>
  );
};

export default Page;
